export default function Auth({next, router}) {
    if (!localStorage.getItem('token')) {
        return router.push({ name: 'login' });
    }

    return next();
}



// WEBPACK FOOTER //
// ./src/middleware/Auth.js